import { IAlertVariantsEnum } from "@organisms/alert/types";

import type { IIconProps } from "@atoms/icon";

export const getAlertIconProps = (
  variant: IAlertVariantsEnum,
  customIcon?: IIconProps,
): IIconProps => {
  if (customIcon) return customIcon;
  switch (variant) {
    case IAlertVariantsEnum.Information:
      return { name: "InformationFill", color: "primary-base" };
    case IAlertVariantsEnum.Error:
      return { name: "ErrorWarningFill", color: "state-error-base" };
    case IAlertVariantsEnum.Success:
      return { name: "CheckboxCircleFill", color: "state-success-base" };
    case IAlertVariantsEnum.Warning:
      return { name: "AlertFill", color: "state-warning-base" };
    default:
      return { name: "InformationFill", color: "primary-base" };
  }
};
